import React from "react";
import { useSelector } from "react-redux";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { skipToken, useTaskSubmissionGroupsFilterQuery } from "API";

import { userSelectors } from "store/user/userSelectors";

import useFilterParam from "./useFilterParam";

const SubmissionGroupByOrg: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("submissionGroup");

  const currentOrg = useSelector(userSelectors.currentOrganisation);
  const {
    data = [],
    isSuccess,
    isError,
  } = useTaskSubmissionGroupsFilterQuery(
    currentOrg ? { organisationId: currentOrg.id } : skipToken,
    {
      selectFromResult: (result) => ({
        ...result,
        data: result.data
          ?.filter(
            (item, index, arr) =>
              arr.findIndex((i) => i.label === item.label) === index
          )
          ?.map((item) => ({
            value: item.label,
            label: item.label,
          })),
      }),
    }
  );
  const [selected, setSelected] = useFilterParam("submissionGroupByOrg", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!isSuccess}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default SubmissionGroupByOrg;
